import { isArray, isEmpty, negate, some } from 'underscore';

/**
 * @typedef {Object} EntityAndParentID
 * @property {string|number} EntityID Entity ID
 * @property {string|number} ParentID Parent Entity ID
 */


/**
 * @typedef {Object} AppealBaseOptions
 * @property {number} cid Customer ID
 * @property {number} aid Account ID
 * @property {Object} permissions Permissions
 */

const isValidEntityAndParentID = entityAndParentID =>
  entityAndParentID && entityAndParentID.EntityID && entityAndParentID.ParentID;


class AppealBase {
  constructor(options) {
    this.options = options;
  }
}

export class AppealByIDsForParentEntity extends AppealBase {
  /**
   * Initialized AppealByIDsForParentEntity
   * @param {AppealBaseOptions} options options
   * @param {number|string} parentId parent entity ID
   * @param {Array<number|string>} ids array of entity IDs
   */
  constructor(options, parentId, ids) {
    super(options);
    if (!parentId) {
      throw new Error('parentId is required');
    }
    if (!isArray(ids) || isEmpty(ids)) {
      throw new Error('ids is required and must be an array');
    }
    this.parentId = parentId;
    this.ids = ids;
  }
}

export class AppealAllForParentEntity extends AppealBase {
  constructor(options, parentId) {
    super(options);
    if (!parentId) {
      throw new Error('parentId is required');
    }
    this.parentId = parentId;
  }

  createAppealParamsWithIDs(ids) {
    return new AppealByIDsForParentEntity(this.options, this.parentId, ids);
  }
}

export class AppealByIDs extends AppealBase {
  /**
   * Initialized AppealByIDs
   * @param {AppealBaseOptions} options options
   * @param {Array<EntityAndParentID>} ids array of entity+parent entity IDs
   */
  constructor(options, ids) {
    super(options);
    if (!isArray(ids) || isEmpty(ids) || some(ids, negate(isValidEntityAndParentID))) {
      throw new Error('ids is required and must be an array of EntityAndParentID');
    }
    this.ids = ids;
  }
}

export class AppealAllByFilter extends AppealBase {
  constructor(options, filter) {
    super(options);
    if (!filter) {
      throw new Error('filter is required');
    }
    this.filter = filter;
  }
}
